import { useQuery } from "@tanstack/react-query";
import React from "react";
import styled from "styled-components";
import Table from "../../components/core-components/Table.tsx";
import Modal from "../../components/core-components/Modal.tsx";
import { toast, ToastContainer } from "react-toastify";
import PageHeader from "../../components/PageHeader.tsx";
import Scrollbars from "react-custom-scrollbars-2";
import { useNavigate } from "react-router-dom";
import { getInvoicess, getOrders } from "../../../services/orderService.js";
import ManualInvoice from "../../components/ManualInvoice.tsx";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;
const Content = styled.div`
  box-sizing: border-box;
  background-color: white;
  width: calc(100% - 2rem);
  min-height: 80%;
  border-radius: 8px;
  padding: 20px;

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

interface Props {}

const InvoicePage: React.FC<Props> = ({}) => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const navigate = useNavigate();
  const { data: orders = [] } = useQuery({
    queryKey: ["invoices"],
    queryFn: () => getInvoicess(),
  });

  return (
    <Wrapper>
      <PageHeader
        pageTitle="Facturi"
        actionButtons={[
          {
            label: "Generează factură manual",
            onClick: () => {
              setModalOpen(true);
            },
            isEmpty: true,
          },
        ]}
      />
      <Content>
        <Scrollbars style={{ width: "100%" }}>
          <Table
            columns={[
              { title: "ID comandă", key: "orderID" },
              { title: "Număr factură", key: "invoiceNumber" },
              { title: "Dată factură", key: "invoiceDate" },
              { title: "Suma totală", key: "totalPrice" },
              { title: "Nume", key: "name" },
              { title: "Telefon", key: "phoneNumber" },
            ]}
            rows={orders.map((order) => ({
              ...order,
              invoiceNumber: order.invoice.invoiceID,
              invoiceDate: order.invoice.invoiceDate,
              totalPrice: `${order.totalPrice} lei`,
              name: `${order.firstName} ${order.lastName}`,
            }))}
            onRowClick={(row) => {
              row?.orderID &&
                navigate("/backoffice/orders/" + row?.orderID.toString());
            }}
          />
        </Scrollbars>
      </Content>

      {isModalOpen && (
        <Modal
          name="add-manula-invoice-modal"
          title={"Generez factură manual"}
          onClose={() => setModalOpen(false)}
          content={<ManualInvoice />}
          isFullHeight
        />
      )}
      <ToastContainer />
    </Wrapper>
  );
};
export default InvoicePage;
